"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LINKED_GOAL_NO_PACE_COPY = exports.LINKED_CHECKING_GOAL_COPY = void 0;
exports.goalAccountAllowed = goalAccountAllowed;
/**
 * Goals backed by an everyday checking account (BEN-141 FP-021 / FP-053).
 *
 * A goal linked to checking showed that account's balance as "saved", while
 * Forecast showed the same money as "Available to Spend": one $500 told to the user
 * twice. Paul (2026-10-06): new links take savings-type accounts only; existing
 * checking-backed goals keep working, and their card says so from day one ("the
 * users being told the same $500 twice are the ones who already did this").
 */
exports.LINKED_CHECKING_GOAL_COPY = "Follows your everyday checking. This money is also counted as spendable.";
/**
 * FP-091's other half: a linked goal takes no contributions (its figure is the
 * account's), so "Log a contribution and we'll project a date." pointed at an
 * action the card no longer offers.
 */
exports.LINKED_GOAL_NO_PACE_COPY = "This goal follows your account's balance, so there's no contribution pace to project.";
/** Whether a NEW link may use an account of this category: savings only. */
function goalAccountAllowed(accountCategory) {
    return accountCategory === "savings";
}
//# sourceMappingURL=goalAccountCopy.js.map